import ability from '@/store/ability'
import axios from '@/axios'

const getAbilities = async () => {
  if (localStorage.getItem('token')) {
    try {
      const { data } = await axios.get(`/v1/auth/abilities`)
      ability.update(data)
    } catch (err) {
      ability.update([])
    }
  } else {
    ability.update([])
  }
}

const getAbilityGroups = async ({commit}) => {
  const { data } = await axios.get(`/v1/ability-groups`)
  commit('SET_ABILITY_GROUPS', data)
}

export default {
  getAbilities,
  getAbilityGroups
}
